import { from, of } from "rxjs"
import { ofType } from "redux-observable"
import { switchMap, catchError } from "rxjs/operators"
import { push } from "connected-react-router"
import {
    fetchEmailNotificationsSuccess,
    createNewEmailsSuccess,
    updateEmailsSuccess,
} from "./actions"
import { hideLoader } from "../loader/actions"
import emailNotificationsApi from "../../api/emailNotifications-api"
import * as types from "./actionTypes"
import * as errorActions from "../error/actions"

export function fetchAllEmailNotificationsData(action$) {
    return action$.pipe(
        ofType(types.EMAIL_NOTIFICATION_FETCH_DATA),
        switchMap(() =>
            from(emailNotificationsApi.getAllEmails()).pipe(
                switchMap((data) =>
                    of(
                        fetchEmailNotificationsSuccess(
                            data.data !== null
                                ? data.data[0]
                                : {
                                      configData: {
                                          car_actions: "",
                                          car_orders: "",
                                          general_placements: "",
                                          switch_requests: "",
                                      },
                                  }
                        ),
                        hideLoader()
                    )
                ),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function createNewEmails(action$) {
    return action$.pipe(
        ofType(types.CREATE_NEW_EMAILS),
        switchMap((action) =>
            from(emailNotificationsApi.createEmails(action.payload)).pipe(
                switchMap(() => of(createNewEmailsSuccess(), hideLoader())),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}

export function updatEmails(action$) {
    return action$.pipe(
        ofType(types.UPDATE_EMAILS),
        switchMap((action) =>
            from(
                emailNotificationsApi.updateEmails(
                    action.payload.emails,
                    action.payload.configId
                )
            ).pipe(
                switchMap(() => of(updateEmailsSuccess(), hideLoader())),
                catchError((error) =>
                    of(
                        push("/error"),
                        errorActions.setError(error),
                        hideLoader()
                    )
                )
            )
        )
    )
}
